import { TAG } from 'core/constants/constant';
import { Helmet } from 'react-helmet-async';

export interface IProps {
  /// should optimally have length <= 60 characters
  title?: string

  /// should optimally have 150 <= length <= 160 characters
  description?: string

  /// can be relative or absolute or will use a fallback image if not set
  imageUrl?: string

  keywords?: string

  structuredData?: any;
}

/// Drop-in SEO handling of metadata for your page. Does handle vanilla meta tags,
/// opengraph tags for facebook/linkedin/... and twitter cards tags for
/// twitter/slack/... .
export const MetaTags = (props: IProps) => {
  return (
    <>
      { !process.env.REACT_APP_ENV?.startsWith('prod') && <NoRobotMetaTags /> }
      <TitleMetaTags {...props} />
      <DescriptionMetaTags {...props} />
      <KeywordMetaTags {...props} />
      <StructuredData structuredData={props.structuredData} />
    </>
  );
}

// apply some branding addendum automatically if not deactivated
const TitleMetaTags = ({ title }: IProps) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta property="twitter:title" content={title} />
    </Helmet>
  );
}

// use the given description as-is
const DescriptionMetaTags = ({ description = TAG.description }: IProps) => {
  return (
    <Helmet>
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      <meta property="twitter:description" content={description} />
    </Helmet>
  );
}


// use the given keywords as-is
const KeywordMetaTags = ({ keywords }: IProps) => {
  return (
    <Helmet>
      <meta name="keywords" content={keywords} />
      <meta property="og:keywords" content={keywords} />
      <meta property="twitter:keywords" content={keywords} />
    </Helmet>
  );
}

const NoRobotMetaTags = () => {
  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
}

const StructuredData = ({ structuredData }:any) => {
  const hasStructure = !!structuredData && Object.keys(structuredData).length > 0;
  return hasStructure ? (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
    </Helmet>
  ) : <></>;
}
